import { COOKIES } from "constants/cookies";
import { getCookie } from "./cookies";
import { collectionHeader } from "./sardine";

export const makeAuthorizationToken = (config) => {
  if (!config.headers) {
    config.headers = {};
  }
  const token = getCookie(COOKIES.TOKEN);
  const hasAuthorizationHeader = !!config.headers.Authorization;
  if (!!token && !hasAuthorizationHeader) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

export const addXSessionHeader = (config) => {
  if (!config.headers) {
    config.headers = {};
  }
  const existingSession =
    (typeof config.headers.get === "function" &&
      config.headers.get("X-Session")) ||
    config.headers["X-Session"] ||
    config.headers["x-session"];
  if (!existingSession) {
    const xSession = getCookie(COOKIES.X_SESSION);
    if (xSession) {
      config.headers["X-Session"] = xSession;
    }
  }
  const collection = collectionHeader();
  if (collection) {
    config.headers["X-Risk-Collection"] = collection;
  }
  return config;
};

const getRequestPathname = (config) => {
  try {
    if (!config.url) return null;
    const url =
      config.url.startsWith("http://") || config.url.startsWith("https://")
        ? new URL(config.url)
        : new URL(config.url, config.baseURL || "http://dummy");
    return url.pathname;
  } catch {
    return null;
  }
};

const addApiV1Headers = (config) => {
  const pathname = getRequestPathname(config);
  if (!pathname || !pathname.startsWith("/api/v1")) {
    return config;
  }
  if (!config.headers) {
    config.headers = {};
  }
  addXSessionHeader(config);
  return makeAuthorizationToken(config);
};

export const setupInterceptors = (instance) => {
  instance.interceptors.request.use(addApiV1Headers);
};
